import { get, put } from './client.js';

export const getContext = () => get('/session/context');

export const switchOrg = (orgId) =>
  put('/session/context/org', { orgId });

export const switchWorkspace = (workspaceId) =>
  put('/session/context/workspace', { workspaceId });
